module.exports = __webpack_public_path__ + "static/media/fitness-sf.25239fdc.svg";